$(document).ready(function () {
    //------------------------------------
    // OPEN VIDEO IN FULLSCREEN

    $(document).on('click', '[data-remodal-target]', function (e) {
        var src = $(this).data('src');
        if ($(window).height() > $(window).width()) {
            console.log("higher than wide");
            if ($(this).data('src-vertical') && $(this).data('src-vertical').length > 0) {
                src = $(this).data('src-vertical');
                console.log("vertical: " + src);
            }
        }
        $("iframe#vimeoiframe").attr('src', src);
    });
    
    $(document).on('closed', '.remodal', function (e) {
        $("iframe#vimeoiframe").attr('src', '');
    });

    $(document).on('opened', '.remodal', function () {
        var player = new Vimeo.Player($("iframe#vimeoiframe"));

        player.on('ended', function () {
            $('.remodal').remodal().close();
        });
    });
});